import * as Yup from 'yup';
import { InitialCausality } from '../../../../../../shared/types/typifications/initialCausality';

export const initialValues: InitialCausality = {
    product: '',
    motive: '',
    typePqr: '',
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
    category: '',
    process: '',
    subprocess: '',
    riskId: '',
    risk: '',
    riskImpact: '',
    consequence: '',
    sfcMotiveClaim: '',
    sfcSubaccount: '',
    sfcMotive: '',
    sfcSubmotive: '',
    sfcMotiveIdComplaint: '',
    sfcMotiveIdComplaintOld: '',
    typeComplaint: '',
    motiveName: '',
    motiveDescription: '',
    active: true,
};

export const validationSchema = (
    hasSubmotive1: boolean,
    hasSubmotive2: boolean,
    hasSubmotive3: boolean,
    hasSubmotive4: boolean
) => {
    const schema: any = {
        product: Yup.string().required('El producto es obligatorio'),
        motive: Yup.string().required('El motivo es obligatorio'),
        typePqr: Yup.string().required('El tipo Pqr es obligatorio'),
        category: Yup.string().required('La categoria es obligatorio'),
        process: Yup.string().required('El proceso es obligatorio'),
        subprocess: Yup.string().required('El subproceso es obligatorio'),
        riskId: Yup.string().required('El NO. riesgo es obligatorio'),
        risk: Yup.string().required('El riesgo es obligatorio'),
        riskImpact: Yup.string().required(
            'El impacto del riesgo es obligatorio'
        ),
        consequence: Yup.string().required('La consecuencia es obligatorio'),
        sfcMotiveClaim: Yup.string().required(
            'El Motivo de reclamación SFC es obligatorio'
        ),
        sfcSubaccount: Yup.string().required('La Subcuenta SFC es obligatorio'),
        sfcMotive: Yup.string().required(
            'El Motivo [SECTOR - FASECOLDA] es obligatorio'
        ),
        sfcSubmotive: Yup.string().required(
            'El Motivo [SECTOR - FASECOLDA] es obligatorio'
        ),
        sfcMotiveIdComplaint: Yup.string().required(
            'El motivo de reclamación SFC es obligatorio'
        ),
        sfcMotiveIdComplaintOld: Yup.string().required(
            'El Código motivo quejas sector SFC(Anterior) es obligatorio'
        ),
        typeComplaint: Yup.string().required('El tipo de queja es obligatorio'),
        motiveName: Yup.string().required(
            'El nombre Motivo de Queja SFC es obligatorio'
        ),
        motiveDescription: Yup.string().required(
            'La descripción Motivo de Quejas SFC es obligatorio'
        ),
    };

    if (hasSubmotive1)
        schema.submotive1 = Yup.string().required(
            'El submotivo 1 es obligatorio'
        );
    if (hasSubmotive2)
        schema.submotive2 = Yup.string().required(
            'El submotivo 2 es obligatorio'
        );
    if (hasSubmotive3)
        schema.submotive3 = Yup.string().required(
            'El submotivo 3 es obligatorio'
        );
    if (hasSubmotive4)
        schema.submotive4 = Yup.string().required(
            'El submotivo 4 es obligatorio'
        );

    return Yup.object(schema);
};
